import { TICK_HZ } from '../sim/tuning';

/** 0:21.34 style lap time from ticks. */
export function fmtTime(ticks: number | null): string {
  if (ticks === null) return '-:--.--';
  const cs = Math.floor((ticks * 100) / TICK_HZ);
  const m = Math.floor(cs / 6000);
  const s = Math.floor((cs % 6000) / 100);
  const c = cs % 100;
  return `${m}:${String(s).padStart(2, '0')}.${String(c).padStart(2, '0')}`;
}

/** +0.42 / -1.07 split delta from ticks. */
export function fmtDelta(ticks: number): string {
  const s = Math.abs(ticks) / TICK_HZ;
  return `${ticks <= 0 ? '-' : '+'}${s.toFixed(2)}`;
}
